import React, { FC, useState } from 'react';

import { WorkListTable } from './components';

const WorkList: FC = () => {
  const [readOnly] = useState<boolean>(window.location.pathname.indexOf('arc') >= 0);

  return (
    <div>
      <WorkListTable isArch={readOnly} />
    </div>
  );
};

export default WorkList;
